import createEnum from 'enumpup';

import * as AlphaUtils from './alpha';
import * as Survive from './survive';

export const GameStatus = createEnum( 'INIT', 'PLAY', 'DEFEAT', 'ADVANCE', 'VICTORY');
export const GameType = createEnum( 'SURVIVE' );

export const VOWEL_COST = 2;
export const REFRESH_COST = 5;

/*
  Attacks
    Drain
      No Cooldown
      No Duration
      Power
      No Limit
      No Row
      No Col
      Simply subtracts drain power from player's energy
    Poison
      Cooldown
      Duration
      Power
      No Limit
      No Row
      No Col
      Poisons the vowel pool each vowel at the end of the turn drains
      power x number of vowels
    Choke
      Cooldown
      Duration
      No Power
      Limit
      No Row
      No Col
      Limits the size of the vowel pool. Removes any vowels in excess of the
      limit.
    Freeze
      Cooldown
      Duration
      No Power
      No Limit
      Row
      Col
      Freezes a row or col of letters in the letter box, frozen letters may not
      be played.
*/


/**
 * Function to calculate changes for advancing a level
 * in the survival game.
 *
 * @param {int} energy current energy amount
 * @param {int} level current game level
 * @return {object} updated values
 */
export function advanceSurvival(energy, level) {
  const opponent = Survive.surviveAlpha[level + 1];
  return {
    energy: energy + Survive.ENERGY_PER,
    survive: {level: level + 1},
    health: opponent.health,
    drain: opponent.powers.drain,
    foe: opponent.foe,
    status: GameStatus.PLAY,
  };
}

/**
 * Populates the letter box
 *
 * @return {array} array of letters
 */
export function populateBox() {
  const newBoxes = [];
  const letterSet = AlphaUtils.getLetterSet();
  for (let index = 0; index < 12; index++) {
    newBoxes.push({val: AlphaUtils.getLetter(letterSet), index: index});
  }
  return newBoxes;
}

/**
 * Updates the best word list.
 * @param {array} bestWords array of current best words
 * @param {string} text the new to word to perhaps add
 * @param {score} score the score of the current word
 * @return {array} updated best words array
 */
export function updateBest(bestWords, text, score) {
  for (let i = 0; i < bestWords.length; i++) {
    if (bestWords[i].word === text) {
      return bestWords;
    }
  }

  let newBestWords = [];
  let inserted = false;
  if (bestWords.length > 0) {
    bestWords.forEach((best) => {
      if (!inserted && best.score < score) {
        newBestWords.push({word: text, score: score});
        inserted = true;
      }
      newBestWords.push(best);
    });
  }
  if (!inserted) {
    newBestWords.push({word: text, score: score});
  }
  if (newBestWords.length > 10) {
    newBestWords = newBestWords.splice(0, 10);
  }
  return newBestWords;
}
